import Image from 'next/image';

import Carousel, {
  SwiperSlide,
} from '@components/Carousel/next/Carousel/CarouselComponent';
import {
  HeroCampaignBannerContainer,
  ImgWrp,
} from '@components/ui/banners/hero-campaign-banner/HeroCampaignBannerStyles';
import { ConceptHotelAnnouncementItemViewModel } from '@api/v3';

import { BannerDetailWrapper } from './BannerStyle';

export interface BannerDetailProps {
  url?: string;
  alt?: string;
}
export interface BannerCarouselProps {
  data: ConceptHotelAnnouncementItemViewModel[];
  onClick?: () => void;
}
export const BannerDetailCarousel = ({
  data,
  onClick,
}: BannerCarouselProps) => {
  return (
    <>
      <HeroCampaignBannerContainer>
        <Carousel
          paginationShow={Boolean(data.length > 1)}
          slider={Boolean(data.length > 1)}
        >
          {data?.map((item, index) => (
            <>
              {item?.images[0] ? (
                <BannerDetailWrapper>
                  <SwiperSlide key={index}>
                    <ImgWrp isHref={Boolean(item)} key={item?.images[0]?.url}>
                      <Image
                        onClick={() => onClick?.()}
                        src={
                          item?.images[0]?.url ||
                          '/static/images/setur-static.jpg'
                        }
                        fill
                        alt={
                          item?.images[0]?.alt ?? 'Setur Görseli Hazırlanmakta'
                        }
                      />
                    </ImgWrp>
                  </SwiperSlide>
                </BannerDetailWrapper>
              ) : null}
            </>
          ))}
        </Carousel>
      </HeroCampaignBannerContainer>
    </>
  );
};

export const BannerDeatail = ({ url, alt }: BannerDetailProps) => {
  return (
    <>
      <HeroCampaignBannerContainer>
        {url ? (
          <Image
            src={url}
            fill
            style={{ objectFit: 'initial' }}
            alt={alt || 'setur'}
          />
        ) : null}
      </HeroCampaignBannerContainer>
    </>
  );
};

export default BannerDeatail;
